<template>
  <div>
    <div class="wrap coaching-finish-wrap">
      <div class="top-header">
        <incBack></incBack>
        <h3>코칭 상세</h3>
      </div>
      <div class="body-wrap">
        <div class="time">
          <img src="@/assets/img/time-icon-b.svg" alt="시간 아이콘" />
          <p>{{ course.startDate }}({{ course.day }}) {{ course.startTime }}~{{ course.endTime }} ({{ course.time }}분)</p>
        </div>
        <div class="coach">
          <div class="w-100per clear">
            <div class="w-50per float-left txt-left">
              <p class="company">{{ course.companyName }}</p>
            </div>
            <div class="w-50per float-left txt-right" @click="viewSurvey(course.userIdx)">
              <span class="survey">서베이 보기</span>
            </div>
          </div>
          <div class="info">
            <h3>{{ course.userName }} <span>과장</span></h3>
            <h4>{{ course.sessionType }}코칭 <span></span>{{ course.currentSession }}회기</h4>
          </div>
          <div class="contact">
            <ul>
              <li>
                <img src="@/assets/img/phone-call.svg" @click="sendCall()" style="margin-right: 15px" v-if="isCall" />
                <img src="@/assets/img/mic.svg" @click="sendWebex()" v-if="isWebex" />
                <img src="@/assets/img/talk-message.svg" alt="대화아이콘" class="ml-20" @click="viewMessage()" />
              </li>
            </ul>
          </div>
        </div>
        <div class="coach-goal">
          <ul>
            <li>
              <h3>관심 코칭 주제</h3>
              <p class="preline">
                <font v-for="(item, index) in embedded" :key="index" :class="{ active: index == 0 }">
                  {{ index + 1 }}. {{ item.parentSubject }} - {{ item.subject }}<br />
                </font>
              </p>
            </li>
            <li>
              <h3>코칭 목표</h3>
              <p class="preline">{{ course.coarchingSubject }}</p>
            </li>
            <li>
              <h3>기타의견</h3>
              <p class="preline">{{ course.coarchingEtc }}</p>
            </li>
          </ul>
        </div>
        <div class="w-90per mg-auto clear">
          <div class="modify-btn w-100per float-left" @click="recomVideo()">
            <a href="">영상 추천하기</a>
          </div>
        </div>
        <div class="coaching-btn">
          <button @click="journalView()">코칭 일지 보기</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
import dayjs from "dayjs";
export default {
  name: "coaching_detail",
  props: {
    sessionIdx: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    course: {},
    embedded: [],
    isWebex: false,
    isCall: false,
  }),
  components: {
    incBack,
  },
  mounted() {
    this.getCoarcingDetail();
  },
  methods: {
    getCoarcingDetail() {
      let params = {
        sessionIdx: this.sessionIdx,
      };
      this.axios
        .get("/front/coarching/reservation/detail", { params })
        .then((res) => {
          if (res.data.success) {
            this.course = res.data.contentinfo.coarchReservationList;
            if (this.course.sessionType.includes("화상")) {
              this.isWebex = true;
            } else {
              this.isWebex = false;
            }
            if (this.course.sessionType.includes("전화")) {
              this.isCall = true;
            } else {
              this.isCall = false;
            }

            this.course.startDate = dayjs(this.course.startDate).format("YYYY-MM-DD HH:mm:ss").replace(/-/g, "/");
            this.$store.commit("setCoachingDays", dayjs(this.course.startDate).day());
            this.course.day = this.$store.state.coachingDays;

            this.course.startTime = dayjs(this.course.startDate).format("HH:mm");
            this.course.endTime = dayjs(this.course.endDate).format("HH:mm");
            let timeValue = {
              startTime: this.course.startTime,
              endTime: this.course.endTime,
            };
            this.$store.commit("setCoachingTime", timeValue);
            this.course.time = this.$store.state.coachingTime;

            this.course.startDate = dayjs(this.course.startDate).format("YYYY.MM.DD");

            let temp = this.course.sessionPer.split("/");
            this.course.currentSession = temp[0];

            this.embedded = res.data.contentinfo.userEmbeddedSurvey;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    viewMessage() {
      this.$router.push({ name: "message", params: { userIdx: Number(this.course.userIdx) } });
    },
    viewSurvey(userIdx) {
      this.$router.push({
        name: "embedded_survey_report",
        params: { userIdx: Number(userIdx), sessionIdx: Number(this.sessionIdx) },
      });
    },
    scheduleChange() {
      this.$router.push("/schedule_change");
    },
    recomVideo() {
      // this.$router.push({name:"video_write"});
      this.$router.push({ name: "video_write", params: { isRetake: 0, userIdx: this.course.userIdx } });
    },
    journalView() {
      this.$router.push({ name: "coaching_journal_view", params: { sessionIdx: Number(this.sessionIdx) } });
    },
  },
};
</script>
